import { Button } from "@website/ui/button";

export function AgenciesButton() {
  return (
    <Button
      className="!mx-0 max-lg:!hidden"
      color="neutral"
      href="https://b2b.snapptrip.com/b2b-login"
      role="link"
      size="medium"
      target="_blank"
      variant="text"
      rel="nofollow"
    >
      آژانس ها و شرکت ها
    </Button>
  );
}
